export const THEMES = {
  SPECBYTE: 'SPECBYTE',
  CASHBYCREATIVE: 'CASHBYCREATIVE',
  CCC: 'CCC',
  CREATIVELOVE: 'CREATIVELOVE',
  AUDACYFLASH: 'AUDACYFLASH',
  ADMIN: 'ADMIN',
  BEASLEY: 'BEASLEY'
};

// S3 bucket configuration
export const S3_BUCKET = {
  BASE_URL: 'https://yamanair-digital-assets.s3.amazonaws.com/',
  SAMPLE_DIGITALS_PATH: 'sample-digitals/',
  WALKTHROUGHS_PATH: 'walkthroughs/',
};

/** Brand digital-request walkthroughs (hosted on yamanair-digital-assets). */
export const CCC_DIGITAL_WALKTHROUGH_VIDEO_URL = `${S3_BUCKET.BASE_URL}${S3_BUCKET.WALKTHROUGHS_PATH}ccc-digital-request-walkthrough.mp4`;
/** SpecFlight / CatchFlight reuse the CCC cut until brand-specific walkthroughs are filmed. */
export const SB_DIGITAL_WALKTHROUGH_VIDEO_URL = CCC_DIGITAL_WALKTHROUGH_VIDEO_URL;
export const CBC_DIGITAL_WALKTHROUGH_VIDEO_URL = CCC_DIGITAL_WALKTHROUGH_VIDEO_URL;

function toApiSubdomain(input) {
  const u = new URL(input.startsWith('http') ? input : `https://${input}`);
  const parts = u.hostname.split('.');

  if (parts.length < 2) return input; // invalid domain

  if (parts.length === 2) {
    parts.unshift('api');
  } else {
    parts[0] = 'api';
  }

  return `${u.protocol}//${parts.join('.')}`;
}

function getBackendUrl() {
  const host = window.location.hostname;
  if (host.endsWith('cumuluscreativeconcierge.com')) {
    return process.env.REACT_APP_CCC_NODE_URL;
  }

  if (host.endsWith('specbyte.com') || host.endsWith('audacyflash.com')) {
    return process.env.REACT_APP_SB_NODE_URL;
  }

  if (host.endsWith('cashbycreative.com')) {
    return process.env.REACT_APP_CXC_NODE_URL;
  }

  if (host.endsWith('localhost')) {
    return process.env.REACT_APP_NODE_URL;
  }
  
  return toApiSubdomain(host);
}

export function getSiteCode() {
  const host = window.location.hostname;
  if (host.endsWith('cumuluscreativeconcierge.com')) {
    return 'ccc';
  }
  if (host.endsWith('specbyte.com') || host.endsWith('audacyflash.com')) {
    return 'sb';
  }
  if (host.endsWith('cashbycreative.com')) {
    return 'cbc';
  }

  // TODO: This is a temporary fix for Beasley - do not continue this pattern for future white label sites!
  if (host.endsWith('beasley-creative.com')) {
    return 'bea';
  }

  if (host.startsWith('localhost')) {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (!settings) return 'sb';
    if (settings.theme === THEMES.CCC) return 'ccc';
    if (settings.theme === THEMES.CASHBYCREATIVE) return 'cbc';
    if (settings.theme === THEMES.SPECBYTE) return 'sb';
    // TODO: This is a temporary fix for Beasley - do not continue this pattern for future white label sites!
    if (settings.theme === THEMES.BEASLEY) return 'bea';
  }

  // This does not work because client build does not dynamically set env variables. They are statically set during the build process.
  // https://create-react-app.dev/docs/adding-custom-environment-variables/
  return process.env.REACT_APP_WHITELABEL_ID ?? 'unknown';
}

export const nodeURL = getBackendUrl()